/**
 * Shared loading affordances for the learn app.
 *
 * Lives in its own file (not `shell.tsx`) so `lib/auth.tsx` can use the
 * centered spinner without creating an import cycle
 * (shell → auth → shell).
 */

/** Tiny brand-colored spinner, centered in the viewport. */
export function CenteredLoading(): React.JSX.Element {
  return (
    <div className="flex min-h-dvh items-center justify-center" role="status" aria-label="Loading">
      <div className="size-6 animate-spin rounded-full border-2 border-muted border-t-primary" />
      <span className="sr-only">Loading…</span>
    </div>
  );
}
